import Vue from 'vue';
import Router from 'vue-router';
import errorRoutes from './error';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

/**
 * 批量引入路由文件
 */
export const generateModules = moduleFiles => {
  let routes = [];
  const keys = moduleFiles.keys();
  keys.forEach(key => {
    if (moduleFiles(key)?.default) {
      routes = [...routes, ...moduleFiles(key).default];
    }
  });
  return routes;
};

const constantModules = require.context('./modules/constant', true, /(.*)\.js/);
const constantRoutes = generateModules(constantModules);

/** 初始路由 */
export const routes = [...constantRoutes, ...errorRoutes];

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE ?? '/',
  routes
});

export default router;
